import { pushToDataLayer } from '../../pushToDataLayer';
import {
  GTMEvent,
  GTMEventAttributes,
  GTMEventName,
  GTMVideoAttributes,
} from '../../types';
import { mapToGTMVideoAttributes } from '../../utils';
import { GTMSaveNewVideoInteractionEventArguments } from './types';

export function saveNewVideoInteractionEvent({
  videoAttributes,
  type,
  vehicleData,
  mergedIds,
}: GTMSaveNewVideoInteractionEventArguments) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.SAVED_NEW_VIDEO,
  };

  const gtmVideoAttributes: GTMVideoAttributes =
    mapToGTMVideoAttributes(videoAttributes);

  pushToDataLayer({
    ...eventAttributes,
    type,
    ...(mergedIds ? { merge_ids: mergedIds } : {}),
    ...gtmVideoAttributes,
    ...vehicleData,
  });
}
